import { Header } from "antd/es/layout/layout";

export default function NotFound() {
  return (
    <div>
      <Header
        className="bg-gradient-to-r from-purple-700 to-blue-500 font-bold"
        style={{ color: "white" }}
      >
        {" "}
        ExpenseHut
      </Header>

      <div className="flex justify-center items-center flex-col mt-10 text-center">
        <span className="text-3xl md:text-2xl font-bold">
          Whoops! Something is missing.
        </span>
        <img
          src="/assets/images/404.png"
          alt="not-found"
          style={{ width: 400, height: 400 }}
        />
      </div>
    </div>
  );
}
